document.getElementById('note_close').addEventListener('click', (e) => {
    e.currentTarget.parentNode.classList.add('note--hide')
})